import React from 'react';
import XcelSafetyDashboard from './XcelSafetyDashboard';

function App() {
  return (
    <div className="App">
      <XcelSafetyDashboard />
    </div>
  );
}

export default App;